var _rect, _g, _rect2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMulticloudsupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 54,
    viewBox: "0 0 69 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_148",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 54
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48.1033,
    height: 54,
    transform: "matrix(-1 0 0 1 48.1035 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4586 21.0725L37.1655 20.9989L37.0944 20.7052C36.282 17.3492 34.6639 14.6504 32.2451 12.5867C29.8265 10.5232 27.101 9.50005 24.0513 9.50005C20.293 9.50005 17.111 10.9616 14.4783 13.917C11.8435 16.8748 10.5212 20.4756 10.5212 24.7501V25.1892L10.0857 25.2459C7.91839 25.528 6.12096 26.5711 4.67675 28.4062C3.23003 30.2444 2.50394 32.3934 2.50394 34.8751C2.50394 37.5738 3.34149 39.8436 5.00795 41.7143C6.67247 43.5829 8.66882 44.5001 11.0233 44.5001H35.075C37.9662 44.5001 40.4318 43.3841 42.4973 41.1194C44.5619 38.8555 45.5986 36.0908 45.5986 32.7938C45.5986 29.964 44.841 27.4576 43.3313 25.258C41.8258 23.0644 39.8717 21.6784 37.4586 21.0725Z",
    fill: "#014AAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4586 21.0725L37.1655 20.9989L37.0944 20.7052C36.282 17.3492 34.6639 14.6504 32.2451 12.5867C29.8265 10.5232 27.101 9.50005 24.0513 9.50005C20.293 9.50005 17.111 10.9616 14.4783 13.917C11.8435 16.8748 10.5212 20.4756 10.5212 24.7501V25.1892L10.0857 25.2459C7.91839 25.528 6.12096 26.5711 4.67675 28.4062C3.23003 30.2444 2.50394 32.3934 2.50394 34.8751C2.50394 37.5738 3.34149 39.8436 5.00795 41.7143C6.67247 43.5829 8.66882 44.5001 11.0233 44.5001H35.075C37.9662 44.5001 40.4318 43.3841 42.4973 41.1194C44.5619 38.8555 45.5986 36.0908 45.5986 32.7938C45.5986 29.964 44.841 27.4576 43.3313 25.258C41.8258 23.0644 39.8717 21.6784 37.4586 21.0725Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4586 21.0725L37.1655 20.9989L37.0944 20.7052C36.282 17.3492 34.6639 14.6504 32.2451 12.5867C29.8265 10.5232 27.101 9.50005 24.0513 9.50005C20.293 9.50005 17.111 10.9616 14.4783 13.917C11.8435 16.8748 10.5212 20.4756 10.5212 24.7501V25.1892L10.0857 25.2459C7.91839 25.528 6.12096 26.5711 4.67675 28.4062C3.23003 30.2444 2.50394 32.3934 2.50394 34.8751C2.50394 37.5738 3.34149 39.8436 5.00795 41.7143C6.67247 43.5829 8.66882 44.5001 11.0233 44.5001H35.075C37.9662 44.5001 40.4318 43.3841 42.4973 41.1194C44.5619 38.8555 45.5986 36.0908 45.5986 32.7938C45.5986 29.964 44.841 27.4576 43.3313 25.258C41.8258 23.0644 39.8717 21.6784 37.4586 21.0725Z",
    stroke: "black",
    strokeOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9_148",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 0,
    width: 49,
    height: 54
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48.1033,
    height: 54,
    transform: "matrix(-1 0 0 1 69 0)",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9_148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.3551 21.0725L58.062 20.9989L57.9909 20.7052C57.1785 17.3492 55.5604 14.6504 53.1415 12.5867C50.7229 10.5232 47.9975 9.50005 44.9478 9.50005C41.1895 9.50005 38.0075 10.9616 35.3748 13.917C32.74 16.8748 31.4176 20.4756 31.4176 24.7501V25.1892L30.9822 25.2459C28.8149 25.528 27.0174 26.5711 25.5732 28.4062C24.1265 30.2444 23.4004 32.3934 23.4004 34.8751C23.4004 37.5738 24.238 39.8436 25.9044 41.7143C27.569 43.5829 29.5653 44.5001 31.9198 44.5001H55.9714C58.8627 44.5001 61.3283 43.3841 63.3937 41.1194C65.4584 38.8555 66.4951 36.0908 66.4951 32.7938C66.4951 29.964 65.7375 27.4576 64.2278 25.258C62.7222 23.0644 60.7681 21.6784 58.3551 21.0725Z",
    fill: "#014AAA",
    stroke: "#051881"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMulticloudsupport);
export default __webpack_public_path__ + "static/media/multi cloud support.d30f8d70ee14e1394f4b090a1f3b5492.svg";
export { ForwardRef as ReactComponent };